import { render } from "./ReferrersTableExtra.vue?vue&type=template&id=02982318"
import script from "./ReferrersTableExtra.vue?vue&type=script&lang=js"
export * from "./ReferrersTableExtra.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jenna\\Desktop\\Project\\Outsource\\jy-admin2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__